import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  getPushNotificationState,
  persistPushNotificationState,
  receivePushNotificationState,
  selectUser,
} from '@app/redux';
import { selectConfig } from '@app/redux/config';

import { useMobileEventHandler } from '.';

export const useMobileAppEvents = () => {
  const {
    user: { accountNumber },
  } = useSelector(selectUser);
  const { platform } = useSelector(selectConfig);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getPushNotificationState({ accountNumber }));
  }, [dispatch, accountNumber]);

  useMobileEventHandler({
    receivePushNotificationStatus: (enabled) => {
      dispatch(
        receivePushNotificationState({
          enabled,
          platform,
          accountNumber,
        })
      );
    },
    subscribeToPushNotifications: (data) => {
      dispatch(
        persistPushNotificationState({
          shouldSubscribeToPushNotifications: true,
          platform,
          accountNumber,
          ...data,
        })
      );
    },
    unsubscribeToPushNotifications: (data) => {
      dispatch(
        persistPushNotificationState({
          shouldSubscribeToPushNotifications: false,
          platform,
          accountNumber,
          ...data,
        })
      );
    },
  });
};
